export const LOAD_WITHDRAWS_LIST = 'LOAD_WITHDRAWS_LIST';
export const SWITCH_NOTE = 'SWITCH_NOTE';
export const RESET_WITHDRAWS = 'RESET_WITHDRAWS';
